module.exports = __webpack_public_path__ + "static/media/loading_popup.348c014c.gif";